import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import IndianQrPaymentModal from "./IndianQrPaymentModal";
import { isIndianUser } from "../../utils/paymentCountry";
import { redirectToStripeCheckout } from "../../utils/stripeCheckout";

const CarePlanPaymentHandler = ({ user, userDetails, onPaymentComplete }) => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [service, setService] = useState(null);

  useEffect(() => {
    if (!user?.services?.length) {
      return;
    }

    const latestService = user.services[user.services.length - 1];

    if (isIndianUser(userDetails?.country)) {
      setService(latestService);
      setOpen(true);
      return;
    }

    redirectToStripeCheckout(latestService).catch((error) => {
      console.error("Error creating checkout session:", error);
    });
  }, [user, userDetails]);

  const handleSuccess = () => {
    if (onPaymentComplete) {
      onPaymentComplete();
      return;
    }

    navigate("/user/dashboard");
  };

  return (
    <IndianQrPaymentModal
      open={open}
      onClose={() => setOpen(false)}
      service={service}
      onSuccess={handleSuccess}
    />
  );
};

export default CarePlanPaymentHandler;
